<template>
  <div class="container">
    <div v-if="(isNotAnswer==1&&isAllAnswer==0)||isToAnswer==1" class="problem-container">
		<div class="task-title clearfix"  style="background:#DE0515; color:#fff">
			<h3>{{currentDate}}习题</h3>
			<div class="task-status">
				<span>{{statusAnswer}}</span>
			</div>
		</div>
		<div class="problem-wrap">
			<ul class="problem-ul clearfix">
				<li class="problem-li" v-for="(item,index) in dataList" :key="item.id">
					<h6 :class="{'colorred2': item.answerFlag==2}">{{index+1}}.（{{item.questionTypeName}}）{{item.title}}</h6>
					<ul class="problem-list clearfix" v-if="item.questionTypeId==1">
						<li>
							<el-radio-group v-model="radioArray[index]" @change="changeItem(item)">
								<el-radio :label="subIndex" v-for="(subItem,subIndex) in item.jsonCon.options" :key="subItem.option">{{subItem.option}}.<span style="padding-left: 8px">{{subItem.describe[0].content}}</span></el-radio>
							</el-radio-group>
						</li>
					</ul>
					<ul class="problem-list clearfix" v-if="item.questionTypeId==3">
						<li>
							<el-radio-group v-model="radioArray[index]" @change="changeItem(item)">
								<el-radio label="1">A.<span style="padding-left: 8px">是</span></el-radio>
								<el-radio label="0">B.<span style="padding-left: 8px">否</span></el-radio>
							</el-radio-group>
							
						</li>
					</ul>
					<ul class="problem-list clearfix" v-if="item.questionTypeId==2">
						<li v-if="radioArray[index]">
							<el-checkbox-group v-model="radioArray[index]" v-for="(subItem,subIndex) in item.jsonCon.options" :key="subItem.option" @change="changeItem(item)">
								<el-checkbox :label="subIndex">{{subItem.option}}.<span style="padding-left: 8px">{{subItem.describe[0].content}}</span></el-checkbox>
							</el-checkbox-group>
						</li>
					</ul>
					<div class="answer-wrap colorred2" v-if="isToAnswer==1">正确答案：{{item.answerOption}}</div>
					<div class="answer-wrap colorred2" v-if="isToAnswer==1&&item.analysis">解析：{{item.analysis}}</div>
				</li>
			</ul>
			<div class="btns-single" @click="toCommitBtn" v-if="isToAnswer==0">提 交</div>
		</div>
	</div>
	<ContentNo content="恭喜您完成本轮答题" v-if="isNotAnswer==0&&isToAnswer==0">
		<div slot="result">
			<div class="result-cnt">
			您本轮共做答<span>{{total}}</span>题，正确<span>{{rightAnswer}}</span>题，共获得<span>{{getScoreNum}}</span>积分
			</div>
			<div class="btns-single" @click="toAnswer">查看答案</div>
		</div>
	</ContentNo>
	<ContentNo content="恭喜您完成全部答题" v-if="isAllAnswer==1"/>
	<ContentNo content="暂无答题内容" v-if="dataList.length<=0&&isAllAnswer==0"/>
	<el-dialog title="温馨提示" width="30%" :visible.sync="dialogVisible">
		<div class="dialog-wrap">
			<p>提交成功！本次答题答对{{rightAnswer}}题，获得积分{{getScoreNum}}</p>
			<div class="btns-single" @click="closeDialog('dialogVisible')">参考答案</div>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import { ajaxParam, post } from '../../../../units/request.js'
import ContentNo from '../../../../components/contentno'
export default {
  name: '',
  components: {
    ContentNo
  },
  data(){
	return {
		radioArray: [],
		dataList: [], //试题列表
		radio: '1',
		checkedArray: [],
		questionList: [],
		isNotAnswer: 1, //1未答题  0已答题
		isAllAnswer: 0, //1已答完  0未答完
		currentDate: '',
		dialogVisible: false,
		rightAnswer: 0,
		getScoreNum: 0,
		isShowSubmit: true,
		total: 0,
		isToAnswer: 0,
		statusAnswer: '未完成'
	}
  },
  methods: {
	//获取试题数据列表
	async getDataList(){
		let url = 'v1/question/getEveryDayQuestion'
		let param = {
			userId: this.userId,
			activityId: this.activityId
		}
		ajaxParam(param)
		const res = await post(url, qs.stringify(param))
		if(res.data.code==200) {
			this.dataList = res.data.list
			this.dataList.forEach((item)=>{
				if(this.isToAnswer==1) {
					if(item.questionTypeId==1) {
						this.radioArray.push(Number(item.userAnswer))
					} else if(item.questionTypeId==3) {
						this.radioArray.push(item.userAnswer)
					}else{
						let answerArray  = []
						item.userAnswer.split(',').forEach((item2)=>{
							answerArray.push(Number(item2))
						})
						this.radioArray.push(answerArray)
					}
				} else {
					if(item.questionTypeId==1||item.questionTypeId==3) {
					this.radioArray.push('')
					}
					else{
						this.radioArray.push([])
					}
				}
			})
			// this.dataList.forEach((item)=>{
			// 	console.log(item)
			// 	if(item.questionTypeId==1||item.questionTypeId==3) {
			// 		this.radioArray.push('')
			// 	}
			// 	else{
			// 		this.radioArray.push([])
			// 	}
				
			// })
			this.isNotAnswer = res.data.isNotAnswer
			this.statusAnswer = this.isNotAnswer==1?'未完成':'已完成'
			this.isAllAnswer = res.data.isAllAnswer
			this.rightAnswer = res.data.rightNum
			this.getScoreNum = res.data.integralNum
			this.total = res.data.questionNum
		} else {
			this.$message.error(res.data.msg)
		}
	},
	changeItem(){
		
		//console.log(e)
	},
	toCommitBtn(){
		let isCanCommit= true
		this.radioArray.forEach((item,index)=>{
			if(item.length<=0) {
				isCanCommit = false
				console.log(index)
				return
			}
		})
		if(!isCanCommit){
				this.$message.error('您还有未做答的题！')
			}else {
				this.dataList.forEach((item,index)=>{
					item.result = this.radioArray[index]
					if(item.questionTypeId==2) {
					item.result = item.result.join(',')
					}
					this.questionList.push({
						questionId: item.id,
						userAnswer: item.result
					})
				})
				//console.log(this.questionList)
				this.toCommit()
			}
		
	},
	async toCommit(){
		let url = 'v1/question/submitEveryDayQuestion'
		let param = {
			activityId: this.activityId,
			userId: this.userId,
			questionList: this.questionList,
			isJson: 1
		}
		ajaxParam(param)
		const res = await post(url, param)
		if(res.data.code==200){
			this.dialogVisible = true
			this.isToAnswer = 1
			this.statusAnswer = '已完成'
			this.rightAnswer = res.data.rightNum
			this.getScoreNum = res.data.integralNum
			this.total = res.data.questionNum
			this.dataList = res.data.list
			//this.isNotAnswer = 0
		} else {
			this.$message.error(res.data.msg)
		}
	},
	getCurrentDay(){
		let date = new Date()
		this.currentDate = date.toLocaleDateString()
	},
	closeDialog(){
		this.dialogVisible = false
	},
	toAnswer(){
		this.isToAnswer = 1
		this.radioArray = []
		this.getDataList()
	}
  },
  created(){
	this.userId = localStorage.getItem('userId')
	this.activityId = localStorage.getItem('activityId')
	this.getDataList()
	this.getCurrentDay()
  }
}
</script>

<style scoped>
.problem-container .task-title{margin-bottom: 0!important;}
.problem-wrap{background:#f4f4f4; padding-bottom: 40px;}
.problem-ul{margin: 0 35px;}
.problem-li{border-bottom: 1px solid #dcdcdc;}
.problem-li h6{ margin-top:15px; margin-bottom: 15px;; line-height:30px; font-size: 20px;}
.problem-list li{display:flex; flex-direction: column; padding-bottom: 8px; font-size: 16px; display: flex; flex-wrap: wrap; color:#777}
.radio{display: inline-block; width:18px; height: 18px; background:#fff; border-radius: 50%; margin-right:10px}
.active i{display: block; width:10px; height: 10px; border-radius: 50%; margin: 4px auto; background:#DE0515}
/* .problem-li:last-of-type{border-bottom: none;} */
.problem-list .el-checkbox{display: flex; align-items: center;}
.problem-list .el-checkbox-group{display: flex; flex-direction: column;}
.problem-list .el-radio{display: flex; align-items: center;}
.problem-li .el-radio,.problem-li .el-checkbox__label{white-space:normal; line-height: 26px;}

.problem-wrap .el-radio__label,.problem-wrap .el-checkbox__label{font-size: 16px!important;}
.el-radio__input.is-checked+.el-radio__label,.el-checkbox__input.is-checked+.el-checkbox__label{color:#DE0515!important}
.el-radio__input.is-checked .el-radio__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{border-color:#DE0515!important; background:#DE0515!important}
.problem-wrap .el-radio__inner,.problem-wrap .el-checkbox__inner {
    width: 16px!important;
    height: 16px!important;
}
.el-checkbox-group{margin-right:20px; margin-bottom: 10px;}
.el-radio{margin-bottom: 10px;}
.el-checkbox__inner::after{
	left: 5px!important;
}
.answer-wrap{padding-bottom:15px;line-height: 20px;}
.result-cnt{padding-top: 20px}
.result-cnt span{padding: 0 2px; color:#DE0515; font-weight: bold;}
.dialog-wrap{margin-top: -20px;}
.dialog-wrap p{padding-bottom: 5px;}
</style>
